// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React from 'react';

import LayoutBackgroundColor from './LayoutBackgroundColor';
import LayoutBackgroundImage from './LayoutBackgroundImage';

interface LayoutBackgroundProps {
  themeSettings: {
    backgroundColor: string;
    backgroundImage?: {url: string};
    backgroundStyle: string;
  };
}
export default function LayoutBackground({
  themeSettings,
}: LayoutBackgroundProps) {
  if (
    themeSettings.backgroundStyle === 'image' &&
    themeSettings.backgroundImage?.url
  ) {
    return <LayoutBackgroundImage src={themeSettings.backgroundImage.url} />;
  }
  return <LayoutBackgroundColor color={themeSettings.backgroundColor} />;
}
